/**
* Autocomplete
*/
export default class Autocomplete {
    constructor(target, options) {
        if(!target || !target.length || !options || !options.source) return;

        target.autocomplete({
            autoFocus: true,
            delay: (options.delay) ? options.delay : 200,
            minLength: (options.minLength) ? options.minLength : 2,
            source: options.source,

            select: function(event, ui) {
                if(options.blur) {
                    target.blur();
                }

                if(options.clear) {
                    target.val('');
                    window.setTimeout(function() {
                        target.val('');
                    }, 10);
                }

                if(options.callback) {
                    options.callback(ui.item);
                }
            }
        });

        if(options.customClass) {
            target.autocomplete('widget').addClass(options.customClass);
        }
        else {
            target.autocomplete('widget').addClass('autocomplete-new');
        }

        if(options.imageItems) {
            target.data('ui-autocomplete')._renderItem = function(ul, item) {
                return $('<li class="autocomplete-image-item"></li>').data('item.autocomplete', item).append('<a href="#"><img src="' + item.image + '">' + item.label + '</a>').appendTo(ul);
            }
        }
        else if(options.renderItem) {
            target.data('ui-autocomplete')._renderItem = options.renderItem;
        }

        if(options.renderMenu) {
            target.data('ui-autocomplete')._renderMenu = options.renderMenu;
        }
    }
}
